import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";

import Table from "../../../Components/Table/Table";

import { helpers } from "@acadia-ui/theme";

import DataStore from "../../../Flux/Stores/LineItemDataStore";
import { fetchLineItems } from "../../../Flux/Actions/LineItemActions";
import LegacyLineItemView from "../features/LegacyViews/LegacyLineItemView";

const classNameComponent = `gos-workbook__auditlevel-lineitem`;
const classNamePrefix = `${classNameComponent}__`;

export default function useLineItem({
	// this comment exists to prevent eslint from making this unreadable.
	auditLevel,
	parentCampaignUniqueID,
	metaData,
	auditLevels,
	fetchMetaData,
	campaignJiraTicketExists
}) {
	const [data, setData] = useState();
	const [config, setConfig] = useState();

	useEffect(() => {
		setData(null);
		setConfig(null);
	}, [parentCampaignUniqueID]);

	const refresh = useCallback(async (parentCampaignUniqueID, auditLevel) => {
		if (parentCampaignUniqueID && auditLevel) {
			try {
				await fetchLineItems(
					{
						platform: { value: auditLevel.PlatformID },
						auditlevel: { value: auditLevel.AuditLevelID }
					},
					parentCampaignUniqueID
				);
				setData(DataStore.getData());
				setConfig(DataStore.getConfig());
			} catch (e) {
				setData(null);
				setConfig(null);
			}
		}
	}, []);

	helpers.useAsyncEffect(() => {
		if (parentCampaignUniqueID && auditLevel && metaData.CampaignUniqueIDCode == parentCampaignUniqueID && auditLevel.PlatformID == metaData.PlatformID) {
			refresh(parentCampaignUniqueID, auditLevel);
		}
	}, [parentCampaignUniqueID, auditLevel]);

	const Component = useCallback(
		({ refreshMap }) => {
			if ((data && config && metaData, fetchMetaData)) {
				return (
					<div className={`gos-workbook__auditlevel ${classNameComponent}`}>
						<LegacyLineItemView
							campaignMetaData={metaData}
							auditLevelData={auditLevels}
							getCount={() => {}}
							getPlacementCount={() => {}}
							updateCounts={async () => {
								// ["InsertionOrder", "LineItem"].forEach((name) => refreshMap?.[name]?.());
								await refreshMap?.LineItem?.();
								await refreshMap?.InsertionOrder?.();
							}}
							updateMetaData={fetchMetaData}
							campaignJiraTicketExists={campaignJiraTicketExists}
						/>
					</div>
				);
			}
			return <></>;
		},
		[config, data, metaData, fetchMetaData, campaignJiraTicketExists]
	);

	return useMemo(
		() => ({
			Component,
			data,
			refresh
		}),
		[Component, data, refresh]
	);
}
